// extracted by mini-css-extract-plugin
export var logo = "_5d-2";
export var logoWrapper = "_5d-1";
export var strip = "_5d-0";